import React, { useCallback, useMemo } from "react"
import { Theme } from "@material-ui/core"
import { useTheme } from "@material-ui/styles"
import Particles from "react-tsparticles"
import { loadFull } from "tsparticles"
import type { Engine } from "tsparticles-engine"
import { BackgroundType, useSettings } from "../contexts/SettingsProvider"
import { getBackgroundParticles } from "../themes/backgroundParticles"
import FallingLeavesBackground from "./FallingLeavesBackground"
import FallingSnowBackground from "./FallingSnowBackground"
import StarfieldBackground from "./StarfieldBackground"
import BubblesBackground from "./BubblesBackground"
import CityBackground from "./CityBackground"

export default function CanvasBackground() {
    const theme = useTheme<Theme>()
    const { backgroundType } = useSettings()

    const particlesInit = useCallback(async (engine: Engine) => {
        await loadFull(engine)
    }, [])

    const options = useMemo(
        () => getBackgroundParticles(backgroundType, theme),
        [backgroundType, theme]
    )

    if (backgroundType === BackgroundType.None) {
        return null
    }

    if (backgroundType === BackgroundType.FallLeaves) {
        return (
            <div className="backgroundParticles">
                <FallingLeavesBackground />
            </div>
        )
    }

    if (backgroundType === BackgroundType.Snow) {
        return (
            <div className="backgroundParticles">
                <FallingSnowBackground />
            </div>
        )
    }

    if (backgroundType === BackgroundType.Stars) {
        return (
            <div className="backgroundParticles">
                <StarfieldBackground />
            </div>
        )
    }

    if (backgroundType === BackgroundType.Bubbles) {
        return (
            <div className="backgroundParticles">
                <BubblesBackground />
            </div>
        )
    }

    if (backgroundType === BackgroundType.City) {
        return (
            <div className="backgroundParticles">
                <CityBackground />
            </div>
        )
    }

    return (
        <div className="backgroundParticles">
            <Particles
                key={backgroundType}
                id="background-particles"
                init={particlesInit}
                options={options}
            />
        </div>
    )
}
